import React from 'react';
import { useTranslation } from 'react-i18next';
import './LTISessionExpired.scss';

const LTISessionExpired = () => {
  const { t } = useTranslation();
  return (
    <div className="session-expired alert alert--warning">
      <div className="alert__icon icon-warning-outline"></div>
      <div className="alert__message">
        <h4>{t('LTI.sessionExpired')}</h4>
        <div>{t('LTI.sessionExpiredMsg')}</div>
      </div>
    </div>
  );
};

export default LTISessionExpired;
